import { z } from "zod";
import { IdSchema } from "./primitives";

/** Who holds the game master role. Only the system records it, each time it changes. */
export const GameMasterOperationSchema = z.discriminatedUnion("type", [
  z.strictObject({
    type: z.literal("gameMaster.assigned"),
    /** The running agent that now holds the role. No agent holds it twice. */
    agentId: IdSchema,
    /** The published agent version it runs. */
    agentVersionId: IdSchema,
  }),
  z.strictObject({ type: z.literal("gameMaster.unassigned") }),
]);
export type GameMasterOperation = z.infer<typeof GameMasterOperationSchema>;
